import { Button } from "@mui/material"
import DeleteIcon from '@mui/icons-material/Delete';

export const DeleteButton = (props: any) => {
    return (
        <Button variant="text" color="error" startIcon={<DeleteIcon />} onClick={props.onClick}>
            {props.children}
        </Button>
    )
}